/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Review_Outcome_DeclinedInputs */



/**
* | output |
* | --- |
* | "Declined - Chat Remains Blocked" |
*
* @param {Audit_Details_Review_Outcome_DeclinedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_review_outcome_declined = /** @type {((inputs?: Audit_Details_Review_Outcome_DeclinedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Review_Outcome_DeclinedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Abgelehnt - Chat bleibt blockiert")
	return /** @type {LocalizedString} */ ("Declined - Chat Remains Blocked")
});